import React from 'react';
import { renderMessageHtml } from '../utils/markdown';

// Renders an assistant reply as sanitized Markdown HTML, memoized on its inputs.
// Parsing + sanitizing only re-runs when `text` (or `className`) changes, so
// unrelated parent re-renders — prompt rotation, the typing indicator, hover
// animations — don't repeatedly re-parse Markdown for the whole chat history.
// `className` lets each chat surface scope its own Markdown styling.
const MarkdownMessage = React.memo(function MarkdownMessage({ text, className }) {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: renderMessageHtml(text) }}
    />
  );
});

export default MarkdownMessage;
